import React, {
  createContext, useContext, useState, useEffect
} from 'react';
import { node } from 'prop-types';
import { usePromoModel } from './PromoModelProvider';
import {
  emptyPromoCart, transformCartModelToPromoCart
} from '../utils/promo-cart-utils';
import { useCart } from '../hooks/useCart';

export const PromoCartContext = createContext();

export const usePromoCart = () => useContext(PromoCartContext);

export const PromoCartProvider = ({ children }) => {
  const {
    isBogo, isMsb, minPurchaseQuantity, minPurchaseAmount, allItemIds, anchorItemId, storeId
  } = usePromoModel();
  const [promoCart, setPromoCart] = useState(emptyPromoCart);
  const [bogoSelectedProduct, setBogoSelectedProduct] = useState();
  const {
    CartModel,
    addToCart,
    updateCart,
    isCartLoading,
    setIsCartLoading
  } = useCart();

  useEffect(() => {
    window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('buybox.bogoSelectedProduct', bogoSelectedProduct);
  }, [bogoSelectedProduct]);

  useEffect(() => {
    if (promoCart?.freeItemInCart) {
      setBogoSelectedProduct(null);
    }
  }, [promoCart]);

  // go to useMemo with stringified rawcart comparison
  useEffect(() => {
    if (CartModel && anchorItemId) {
      const newPromoCart = transformCartModelToPromoCart(
        CartModel,
        isBogo,
        isMsb,
        minPurchaseQuantity,
        minPurchaseAmount,
        allItemIds,
        anchorItemId,
        bogoSelectedProduct
      );
      if (newPromoCart) setPromoCart(newPromoCart);
    }
  }, [
    CartModel, isBogo, isMsb, minPurchaseQuantity, minPurchaseAmount, allItemIds, anchorItemId, bogoSelectedProduct
  ]);

  if (!anchorItemId || !storeId || !promoCart) return null;
  const contextValue = {
    // promoCart is only mutated as a sideEffect of updating rawCartModel
    promoCartValue: promoCart.promoCartValue,
    promoCartQuantity: promoCart.promoCartQuantity,
    promoCartItemsObj: promoCart.promoCartItemsObj,
    promoSuccessLevel: promoCart.promoSuccessLevel,
    hasAnchorItemInCart: promoCart.hasAnchorItemInCart,
    freeItemInCart: promoCart.freeItemInCart,
    bogoSelectedProduct,
    setBogoSelectedProduct,
    CartModel,
    addToCart,
    updateCart,
    isCartLoading,
    setIsCartLoading
  };

  return (
    <PromoCartContext.Provider value={contextValue}>
      { children }
    </PromoCartContext.Provider>
  );
};

PromoCartProvider.propTypes = {
  children: node.isRequired
};
